module.exports = __webpack_public_path__ + "f8ad2a8cdf0dc94d8302fa7da143c4e3.png";